var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRankNcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 16,
    rx: 2,
    fill: "#89DA8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14 12H6.872L4.232 5.412C4.304 5.98 4.36 6.516 4.4 7.02C4.448 7.516 4.472 8.1 4.472 8.772V12H2.876V3.696H5.096L7.784 10.296C7.624 9.224 7.544 8.24 7.544 7.344V3.696H9.14V12ZM15.8476 3.696L15.6556 4.98H12.6556V7.14H15.2716V8.412H12.6556V10.704H15.8716V12H10.8916V3.696H15.8476ZM26.2915 3.696L24.8395 12H22.5475L21.3955 5.508L20.1835 12H17.9515L16.5115 3.696H18.2755L19.2235 10.632L20.4835 3.696H22.3435L23.5555 10.632L24.6235 3.696H26.2915Z",
    fill: "#252525"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankNcIcon);
export default __webpack_public_path__ + "static/media/rank-nc-icon.b355133cda612ced3c3a76095b17d32b.svg";
export { ForwardRef as ReactComponent };